<template>
  <a v-if="link" :href="incidentLink" :class="['badge badge-pill', styles]">{{ type }}</a>
  <span v-else :class="['badge badge-pill', styles]">{{ type }}</span>
</template>
<script>
export default {
  name: "IncidentPill",
  props: {
    link: {
      type: Boolean,
      default: false
    },
    baseUrl: {
      type: String,
      default: null
      // required when link is true
    },
    id: {
      type: Number,
      default: null
      // required when link is true, but passed by :v-bind="incident"
    },
    study_id: {
      type: String,
      default: null
      // required when link is true, but passed by :v-bind="incident"
    },
    participant_id: {
      type: Number,
      default: null
      // required when link is true, but passed by :v-bind="incident"
    },
    priority: {
      type: String,
      default: 'Medium'
      // passed by :v-bind="incident"
    },
    type: {
      type: String,
      // required, but passed by :v-bind="incident"
    },
  },
  computed: {
    styles() {
      switch(this.priority) {
        case 'High':
          return 'badge-danger';
        default:
        case 'Medium':
          return 'badge-warning';
        case 'Low':
          return 'badge-info';
      }
    },
    incidentLink() {
      return this.baseUrl + `admin/study/${this.study_id}/participants/${this.participant_id}/incident/${this.id}`;
    },
  }
}
</script>
